import { render } from "./DocumentVerifications.vue?vue&type=template&id=1a9e0af4"
import script from "./DocumentVerifications.vue?vue&type=script&lang=js"
export * from "./DocumentVerifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__